// extracted by mini-css-extract-plugin
module.exports = {"thankYouWrapper":"ThankYou_thankYouWrapper__1jNFC","title":"ThankYou_title__ZX5b0","content":"ThankYou_content__2cTCi"};